export const SectionHead = ({ badge, title, lede, className = "max-w-3xl" }) => (
  <div className={`btr-reveal ${className}`}>
    <span className="btr-badge">
      <span className="dot" />
      {badge}
    </span>
    <h2 className="font-display font-extrabold text-white text-3xl sm:text-4xl lg:text-6xl mt-6 leading-[1.05] sm:leading-[1.02] tracking-tight">
      {title}
    </h2>
    {lede && <p className="font-body text-zinc-400 text-base sm:text-lg mt-6 leading-relaxed">{lede}</p>}
  </div>
);

export const inputCls =
  "btr-input mt-1 w-full bg-[#0a0a0a] border border-white/8 focus:border-[#a2020b] focus:outline-none rounded-md px-4 py-3 text-white font-body text-sm transition-all";

export const labelCls = "font-display text-[11px] tracking-[0.2em] uppercase text-zinc-500";
